import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import Config from '../../../../../Config';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';

const PurpleItem = ({context, item}) => {
  return (
    <div
      className='item-purple'
      onClick={() => {
        // toggleMenuButton();
        prepareSameWindowUrlWithNavigateTo(item?.link?.value, context);
      }}>
      {item?.menuImage?.value != null && (
        <Image style={{marginLeft: '5px'}} src={Config.epiBaseUrl + item?.menuImage?.expandedValue?.url} />
      )}
      <span>{item?.text?.value}</span>
    </div>
  );
};

export default PurpleItem;
